var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-container"},[_c('van-nav-bar',{attrs:{"title":_vm.title,"left-text":"","left-arrow":"","fixed":true},on:{"click-left":_vm.onClickLeft}}),(_vm.ad.adImgUrl)?_c('img',{staticClass:"wxcodeimg",style:(_vm.style),attrs:{"src":_vm.ad.adImgUrl}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }